require("dotenv").config();

module.exports = {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  audience: process.env.VUE_APP_AUTH0_AUDIENCE,
  accountUrl: process.env.VUE_APP_SCALI_ACCOUNT_URL,
  accessTokenName: process.env.VUE_APP_AUTH0_ACCESS_TOKEN_NAME,
};
